module.exports = __webpack_public_path__ + "202408221624/img/huaixiao.28aae400.png";